import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=60ed034c&scoped=true&"
import script from "./Docs.vue?vue&type=script&lang=ts&"
export * from "./Docs.vue?vue&type=script&lang=ts&"
import style0 from "./Docs.vue?vue&type=style&index=0&id=60ed034c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed034c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VApp,VContainer})
